import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { NormalFormComponent } from './pages/normal-form/normal-form.component';
import { ControlComponent } from './pages/control/control.component';
import { ReceivedComponent } from './pages/received/received.component';
import { PublicNotificationsComponent } from './pages/public-notifications/public-notifications.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: NormalFormComponent,
        data: {
          title: 'Melding openbare ruimte - Straatbeeld Online'
        },
      },
      {
        path: 'controle',
        component: ControlComponent,
        data: {
          title: 'Straatbeeld Online'
        },
      },
      {
        path: 'vastgelegd/:unique_number',
        component: ReceivedComponent,
        data: {
          title: 'Straatbeeld Online'
        },
      },
      {
        path: 'publieke-notificatie/:url',
        component: PublicNotificationsComponent,
        data: {
          title: 'Publieke notificatie | Straatbeeld Online'
        },
      },
    ]
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '/'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledNonBlocking',
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
